import { DatePicker, Select, fromUtcDateValue, toUtcDateValue } from '@cinesend/ui-kit'
import { useState } from 'react'
import useStore from '../../hooks/use_store'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import useAuth from '../../hooks/use_auth'
import { modelTypes } from '../../constants/model_types'
import { DISABLED_REASONS } from '../../constants/disabled_reasons'
import SettingsCard from '../../components/settings_card'
import DisabledTooltip from '../../components/disabled_tooltip'

const Details = ({ cycle }) => {
  const { updateModel } = useStore()
  const [state, setState] = useState(cycle)
  const updateState = (data) => setState({ ...state, ...data })
  const queryClient = useQueryClient()
  const { canEditModel: canEditCycle } = useAuth(modelTypes.Cycle, cycle)

  const saveModel = (data) => {
    updateModel.mutate(
      {
        endpoint: 'cycles',
        id: cycle.id,
        data,
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries(['cycles/'])
        },
      }
    )
  }
  const updateField = (data) => {
    updateState(data)
    saveModel(data)
  }
  const { data, isLoading } = useQuery(['schemas'])
  const schemaOptions = data ? data.data.map((schema) => ({ value: String(schema.id), label: schema.name })) : []

  const disabled = !canEditCycle
  const reason = disabled ? DISABLED_REASONS.noPermission : null

  return (
    <>
      <SettingsCard title='Cycle dates'>
        <div className='grid gap-4 sm:grid-cols-2'>
          <DisabledTooltip reason={reason} className='block w-full'>
            <DatePicker
              fullWidth
              label='Start date'
              value={toUtcDateValue(state.start_date)}
              onValueChange={(value) => updateField({ start_date: fromUtcDateValue(value) })}
              disabled={disabled}
            />
          </DisabledTooltip>
          <DisabledTooltip reason={reason} className='block w-full'>
            <DatePicker
              fullWidth
              label='End date'
              value={toUtcDateValue(state.end_date)}
              onValueChange={(value) => updateField({ end_date: fromUtcDateValue(value) })}
              disabled={disabled}
            />
          </DisabledTooltip>
        </div>
      </SettingsCard>
      <SettingsCard title='Schema'>
        <DisabledTooltip reason={reason} className='block w-full'>
          <Select
            fullWidth
            label='Schema'
            value={String(state.schema_id)}
            options={schemaOptions}
            onValueChange={(id) => updateField({ schema_id: Number(id) })}
            disabled={disabled || isLoading}
          />
        </DisabledTooltip>
      </SettingsCard>
    </>
  )
}

export default Details
